import { render, staticRenderFns } from "./DocsUpload.vue?vue&type=template&id=499c95a4"
import script from "./DocsUpload.vue?vue&type=script&lang=ts"
export * from "./DocsUpload.vue?vue&type=script&lang=ts"
import style0 from "./DocsUpload.vue?vue&type=style&index=0&id=499c95a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports